// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portrait .innerWrapper {
    height: 217mm;
}
.landscape .innerWrapper {
    height: 130mm;
}
.inner{
    z-index: 10;
    position: relative;
    width: 100%;
    padding: 10px 1.6cm;
    max-height: 100%;
}
.landscape .inner {
    display: flex;
    justify-content: center;
}
.background-secondary {
    background: gray;
    background-repeat: no-repeat;
    background-size: cover;
}
a {
    color: inherit;
}
.section {
    display: flex;
    width: 100%;
}
.section-title {
    width: 48%;
    background: none;
    border-right: 1px solid var(--psblue);
    text-align: end;
    padding: 5px 20px 5px 0;
}
.subsection-title {
    width: 48%;
    background: none;
    text-align: end;
    padding: 5px 20px 5px 0;
    margin: 10px 0;
}
.section-content, .section-select {
    width: 60%;
    background: none;
    display: block;
    text-align: justify;
    padding: 5px 16px 5px 16px;
}
.section-content {
    cursor: text;
}
.myPlaceholderClassName{
    cursor: pointer !important;
}
.myControlClassName {
    padding: 0 !important;
    cursor: pointer !important;
    border: none !important;
    color: var(--psblue)
}
.myControlClassName:hover {
    outline: none !important;
    box-shadow: none !important;
}
.myArrowClassName {
    top: 8px !important;
    display: none !important;
}
.myMenuClassName {
    padding: 5px;
}
#photo_description {
    width: 100%;
    min-height: 1.2rem;
    height: 100%;
    margin: 0;
}
#inner2 {
    display: flex;
    flex-direction: column;
}
#photoArea{
    width: 100%;
    margin-bottom: 0.5cm;
    max-height: 14cm;
    display: flex;
    justify-content: center;
}
#output{
    max-width:100%;
    max-height:100%;
    width: auto;
    height: auto;
}

[contenteditable=true][placeholder]:empty:before {
    content: attr(placeholder);
    position: absolute;
    color: gray;
    background-color: transparent;
}
*[contenteditable] {
    border: 1px solid transparent;
}
*[contenteditable=true]:hover {
    border: 1px dashed var(--psblue);
}

*[contenteditable=true]:focus {
    outline: none;
}
*[contenteditable=true] *{
    cursor: text;
}

ol {
    margin-left: 0.5cm;
}
ul {
    margin-left: 0.5cm;
}

select {
    border: none;
    overflow-wrap: break-word;
}
select:focus {
    outline: none;
}
select:hover {
    outline: 1px dashed var(--psblue);
    cursor: auto;
}
.copyButton {
    position: absolute;
    right: 25px;
    padding: 5px 0;
}
input[type=date]{
    border: none;
}
input[type=date]:focus{
    border: none;
    outline: none;
}
input[type=date]:hover{
    outline: 1px dashed var(--psblue);
}
input[type=date]:disabled:hover{
    outline: none;
}

.section:nth-child(odd):not(:has(.subsection-title)), .section:not(:has(.subsection-title)):nth-child(odd) .myControlClassName {
    background-color: #EEEEEE !important;
}`, "",{"version":3,"sources":["webpack://./src/valuation/inner/inner.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;AACA;IACI,YAAY;AAChB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,uBAAuB;IACvB;AACJ;AACA;IACI,wBAAwB;IACxB,2BAA2B;AAC/B;AACA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;AACb;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,WAAW;IACX,6BAA6B;AACjC;AACA;IACI,6BAA6B;AACjC;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,aAAa;AACjB;AACA;IACI,iCAAiC;IACjC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,aAAa;AACjB;;AAEA;IACI,oCAAoC;AACxC","sourcesContent":[".portrait .innerWrapper {\n    height: 217mm;\n}\n.landscape .innerWrapper {\n    height: 130mm;\n}\n.inner{\n    z-index: 10;\n    position: relative;\n    width: 100%;\n    padding: 10px 1.6cm;\n    max-height: 100%;\n}\n.landscape .inner {\n    display: flex;\n    justify-content: center;\n}\n.background-secondary {\n    background: gray;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\na {\n    color: inherit;\n}\n.section {\n    display: flex;\n    width: 100%;\n}\n.section-title {\n    width: 48%;\n    background: none;\n    border-right: 1px solid var(--psblue);\n    text-align: end;\n    padding: 5px 20px 5px 0;\n}\n.subsection-title {\n    width: 48%;\n    background: none;\n    text-align: end;\n    padding: 5px 20px 5px 0;\n    margin: 10px 0;\n}\n.section-content, .section-select {\n    width: 60%;\n    background: none;\n    display: block;\n    text-align: justify;\n    padding: 5px 16px 5px 16px;\n}\n.section-content {\n    cursor: text;\n}\n.myPlaceholderClassName{\n    cursor: pointer !important;\n}\n.myControlClassName {\n    padding: 0 !important;\n    cursor: pointer !important;\n    border: none !important;\n    color: var(--psblue)\n}\n.myControlClassName:hover {\n    outline: none !important;\n    box-shadow: none !important;\n}\n.myArrowClassName {\n    top: 8px !important;\n    display: none !important;\n}\n.myMenuClassName {\n    padding: 5px;\n}\n#photo_description {\n    width: 100%;\n    min-height: 1.2rem;\n    height: 100%;\n    margin: 0;\n}\n#inner2 {\n    display: flex;\n    flex-direction: column;\n}\n#photoArea{\n    width: 100%;\n    margin-bottom: 0.5cm;\n    max-height: 14cm;\n    display: flex;\n    justify-content: center;\n}\n#output{\n    max-width:100%;\n    max-height:100%;\n    width: auto;\n    height: auto;\n}\n\n[contenteditable=true][placeholder]:empty:before {\n    content: attr(placeholder);\n    position: absolute;\n    color: gray;\n    background-color: transparent;\n}\n*[contenteditable] {\n    border: 1px solid transparent;\n}\n*[contenteditable=true]:hover {\n    border: 1px dashed var(--psblue);\n}\n\n*[contenteditable=true]:focus {\n    outline: none;\n}\n*[contenteditable=true] *{\n    cursor: text;\n}\n\nol {\n    margin-left: 0.5cm;\n}\nul {\n    margin-left: 0.5cm;\n}\n\nselect {\n    border: none;\n    overflow-wrap: break-word;\n}\nselect:focus {\n    outline: none;\n}\nselect:hover {\n    outline: 1px dashed var(--psblue);\n    cursor: auto;\n}\n.copyButton {\n    position: absolute;\n    right: 25px;\n    padding: 5px 0;\n}\ninput[type=date]{\n    border: none;\n}\ninput[type=date]:focus{\n    border: none;\n    outline: none;\n}\ninput[type=date]:hover{\n    outline: 1px dashed var(--psblue);\n}\ninput[type=date]:disabled:hover{\n    outline: none;\n}\n\n.section:nth-child(odd):not(:has(.subsection-title)), .section:not(:has(.subsection-title)):nth-child(odd) .myControlClassName {\n    background-color: #EEEEEE !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
